export enum EUploadImageType {
  CONTRACT = "CONTRACT",
  PROFILE = "PROFILE",
}
